import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Dialog } from '@inavista/components/ui';

/** The block shown when Payment or Invoice is pressed with the DRO reading outstanding (docs/DRO 4.6). */
@Component({
  selector: 'app-dro-block-dialog',
  standalone: true,
  imports: [Dialog],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <inavista-dialog [open]="open()" title="DRO readings required" width="460px" (dismiss)="cancel.emit()">
      <p class="dro-confirm-text">
        Record the DRO readings for serial <strong>{{ serialNumber() }}</strong> before {{ action() === 'Payment' ? 'taking payment for' : 'invoicing' }} this service order.
      </p>
      @if (message()) { <p class="dro-muted mt-2 mb-0">{{ message() }}</p> }
      <ng-container dialog-actions>
        <div class="dro-actions">
          <button type="button" class="btn btn-sm btn-danger" (click)="cancel.emit()">Cancel</button>
          <button type="button" class="btn btn-sm btn-success" (click)="goToTab.emit()">Go to DRO tab</button>
        </div>
      </ng-container>
    </inavista-dialog>
  `,
  styleUrls: ['./dro.scss'],
})
export class DroBlockDialogComponent {
  readonly open = input(false);
  readonly serialNumber = input('');
  readonly message = input<string | null>(null);
  readonly action = input<'Payment' | 'Invoice'>('Invoice');

  readonly cancel = output<void>();
  readonly goToTab = output<void>();
}
